__turbopack_context__.v({
  "bar": "ci1dfq_bar",
  "icon": "ci1dfq_icon",
  "label": "ci1dfq_label",
  "tab": "ci1dfq_tab",
});
